import { ComoTransactionIdSource } from './como_transaction_id_source.js';

export function name(idSource: ComoTransactionIdSource): string {
  switch (idSource) {
    case ComoTransactionIdSource.ClientID:
      return 'Client ID';
    case ComoTransactionIdSource.OrderID:
      return 'Order ID';
    case ComoTransactionIdSource.SequenceID:
      return 'Sequence ID';
  }
}
